// web端初始化

export const initWeb = function ({ Vue, Store, Router }, { brandCode }) {
  return new Promise((resolve) => {
    resolve()
  })
}
